import { auth, authProvider } from "./firebase";
import { dbApi } from "./db";

const initializeAuth = new Promise((resolve) => {
  auth.onAuthStateChanged((user) => {
    authApi.user = user;
    resolve(user);
  });
});

export const authApi = {
  user: null,
  auth: auth,

  /**
   * Logins with google popup
   * @return Promise. Resolves with {status(str), message(str)} based on the success of the opperations.
   */
  login() {
    return new Promise((resolve) => {
      if (this.user == null) {
        try {
          auth.signInWithPopup(authProvider).then((result) => {
            dbApi.SignUp(result.user.uid, result.user.displayName);
            this.user = result.user;
            resolve({
              status: "success",
              message: "Se ha iniciado sesión exitosamente",
            });
          });
        } catch (error) {
          resolve({
            status: "error",
            message:
              "Ha ocurrido un error intentando iniciar sesión: " +
              error.message,
          });
        }
      } else {
        resolve({
          status: "error",
          message: "El usuario ya se encuentra con una sesión.",
        });
      }
    });
  },

  /**
   * Logs out of Google account
   * @return Promise. Resolves with {status(str), message(str)} based on the success of the opperations.
   */
  logout() {
    return new Promise((resolve) => {
      try {
        auth.signOut().then(() => {
          resolve({
            status: "success",
            message: "Se ha cerrado sesión exitosamente",
          });
        });
      } catch (error) {
        console.log(error.message);
        resolve({
          status: "error",
          message:
            "Ha ocurrido un error intentando cerrar sesión: " + error.message,
        });
      }
    });
  },

  /**
   * Returns the user id (or null if not logged in)
   */
  getUid() {
    if (this.user != null) {
      return this.user.uid;
    } else {
      return null;
    }
  },
  authenticated() {
    return new Promise((resolve) => {
      initializeAuth.then((user) => {
        resolve(auth.currentUser != null);
      });
    });
  },
};
